import { observable, computed, action } from "mobx";
import { asyncAction } from "mobx-utils";
import Autobind from "autobind-decorator";
import AuthModel from "../model/authModel";
import RootStore from "./rootStore";
import jwt from "jsonwebtoken";

// import { jwtDecode } from 'jwt-decode';
/**
 * @class WorklistStore
 * @description 요청에 따른 Study 목록을 반환
 */
@Autobind
class AuthStore {
  _rootStore: RootStore; /// rootStore 객체. 다른 Store를 연계할 때 사용

  @observable
  _authModel = new AuthModel();

  constructor(rootStore: RootStore) {
    this._rootStore = rootStore;
  }
  getUserID() {
    return this._authModel.userID;
  }
  setUserID(userID: string) {
    this._authModel.userID = userID;
  }

  getCredit() {
    return this._authModel.credit;
  }
  setCredit(credit: number) {
    this._authModel.credit = credit;
  }

  getIsSignedIn() {
    return this._authModel.isSignedIn;
  }

  getInfer() {
    return this._authModel.infer;
  }
  setInfer(infer: boolean) {
    this._authModel.infer = infer;
  }

  getMaskInfer() {
    return this._authModel.mask_infer;
  }
  setMaskInfer(mask_infer: boolean) {
    this._authModel.mask_infer = mask_infer;
  }



  @action
  requestSignIn(userID: string, userPassword: string) {
    if (
      (userID === "heeya8876@naver.com" && userPassword === "1q2w3e4r") ||
      (userID === "pak14kr@naver.com" && userPassword === "1q2w3e4r") ||
      (userID === "guest@iaidimage.com" && userPassword === "1q2w3e4r") ||
      (userID === "test@iaidimage.com" && userPassword === "test")
    ) {
      this._authModel.isSignedIn = true;
      this._authModel.userID = userID;
      this._authModel.userPassword = userPassword;
      return true;
    }
    this._authModel.isSignedIn = false;
    return false;
  }

  getConnectApp() {
    return this._authModel.connectApp;
  }

  setConnectApp(connectApp: string) {
    this._authModel.connectApp = connectApp;
  }

  getToken() {
    return this._authModel._token;
  }

  setToken(token: string) {
    this._authModel._token = token;

    fetch(`${process.env.REACT_APP_HOMEPAGE_URL}/api/verify-token`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        if (!res.ok) throw new Error("토큰 검증 실패");
        return res.json();
      })
      .then((data) => {
        this._authModel.isSignedIn = true;
        this._authModel.userID = data.email;

        // 추가적으로 사용자 크레딧 등 필요하면:
        return fetch(`${process.env.REACT_APP_HOMEPAGE_URL}/api/userinfo`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
      })
      .then((res) => {
        if (!res.ok) throw new Error("사용자 정보 가져오기 실패");
        return res.json();
      })
      .then((userInfo) => {
        this._authModel.credit = userInfo.credit;
      })
      .catch((err) => {
        console.error("❌ 인증 오류 발생:", err);
        this._authModel.isSignedIn = false;
        this._authModel._token = null;
      });
  }
}

export default AuthStore;